const normalizers = [
  normalizeLaravel,
  normalizeAxios
];
const normalizeError = (err, translate, log) => {
  for (const normalizer of normalizers) {
    const output = normalizer(err, translate, log);
    if (output) {
      return output;
    }
  }
  return normalizeUnexpected(err, translate, log);
};
function normalizeLaravel(err, _translate) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (((_a = err == null ? void 0 : err.response) == null ? void 0 : _a.status) === 422 && ((_c = (_b = err == null ? void 0 : err.response) == null ? void 0 : _b.data) == null ? void 0 : _c.type) === "/errors/validation" && typeof ((_e = (_d = err == null ? void 0 : err.response) == null ? void 0 : _d.data) == null ? void 0 : _e.violations) && Array.isArray((_g = (_f = err == null ? void 0 : err.response) == null ? void 0 : _f.data) == null ? void 0 : _g.violations)) {
    return (_j = (_i = (_h = err == null ? void 0 : err.response) == null ? void 0 : _h.data) == null ? void 0 : _i.violations) == null ? void 0 : _j.reduce((acc, violation) => {
      acc[violation.propertyPath || violation.errors[0].propertyPath] = {
        value: violation.errors[0].translation || _translate(violation.errors[0].translationKey),
        translationKey: violation.errors[0].translationKey ?? void 0,
        payload: {
          title: err.title,
          text: violation.errors[0].translation || _translate(violation.errors[0].translationKey),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      };
      return acc;
    }, {});
  }
}
function normalizeAxios(err, translate, log) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const customError = ((_b = (_a = err == null ? void 0 : err.response) == null ? void 0 : _a.data) == null ? void 0 : _b.title) || translate((_d = (_c = err == null ? void 0 : err.response) == null ? void 0 : _c.data) == null ? void 0 : _d.key);
  const translationKey = ((_f = (_e = err == null ? void 0 : err.response) == null ? void 0 : _e.data) == null ? void 0 : _f.key) || void 0;
  if ((err == null ? void 0 : err.code) === "ERR_NETWORK" && (err == null ? void 0 : err.name) === "AxiosError" && (err == null ? void 0 : err.message) === "Network Error") {
    return {
      0: {
        value: "Unable to Connect ",
        translationKey,
        payload: {
          title: translate("uikit:message_service.error.axios.title"),
          text: translate("uikit:message_service.error.axios.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_g = err == null ? void 0 : err.response) == null ? void 0 : _g.status) === 401) {
    return {
      0: {
        value: "Authentication error",
        translationKey,
        payload: {
          text: customError ?? translate("uikit:message_service.error.status_401.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_h = err == null ? void 0 : err.response) == null ? void 0 : _h.status) === 403) {
    return {
      0: {
        value: "Access denied",
        translationKey,
        payload: {
          text: customError ?? translate("uikit:message_service.error.status_403.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_i = err == null ? void 0 : err.response) == null ? void 0 : _i.status) === 404 || (err == null ? void 0 : err.code) === "ERR_BAD_REQUEST" && (err == null ? void 0 : err.name) === "AxiosError" && (err == null ? void 0 : err.message) === "Request failed with status code 404") {
    return {
      0: {
        value: customError ?? translate("uikit:message_service.error.status_404.text"),
        translationKey,
        payload: {
          title: translate("uikit:message_service.error.status_404.title"),
          text: customError ?? translate("uikit:message_service.error.status_404.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_j = err == null ? void 0 : err.response) == null ? void 0 : _j.status) === 407) {
    return {
      0: {
        value: "Proxy authentication required",
        translationKey,
        payload: {
          text: customError ?? translate("uikit:message_service.error.status_407.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_k = err == null ? void 0 : err.response) == null ? void 0 : _k.status) === 408) {
    return {
      0: {
        value: "Connection timeout",
        translationKey,
        payload: {
          text: translate("uikit:message_service.error.status_408.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  } else if (((_l = err == null ? void 0 : err.response) == null ? void 0 : _l.status) === 500) {
    log(err);
    return {
      0: {
        value: "Server error",
        translationKey,
        payload: {
          text: customError ?? translate("uikit:message_service.error.status_500.text"),
          icon: true,
          closable: true,
          type: "error"
        },
        error: err
      }
    };
  }
}
function normalizeUnexpected(err, translate, log) {
  let text = translate("uikit:message_service.error.unexpected.text");
  let errorInstance = new Error("Unexpected error", err);
  let translationKey = void 0;
  if (err instanceof Error) {
    if (err.message) {
      text = err.message;
    }
    errorInstance = err;
  } else if (typeof err === "string") {
    text = translate(err);
    if (text !== err) {
      translationKey = err;
    }
    errorInstance = new Error(text);
  }
  log(errorInstance);
  return {
    0: {
      value: text,
      translationKey,
      payload: {
        title: translate("uikit:message_service.error.unexpected.title"),
        text,
        icon: true,
        closable: true,
        type: "error"
      },
      error: errorInstance
    }
  };
}
export {
  normalizeError
};
//# sourceMappingURL=errorNormalizer.es.js.map
